import * as React from "react";
const SvgFiRrCoffinCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coffin-cross_svg__a)">
      <path
        fill="#062147"
        d="m20.57 6.732-1.435-3.589a4.98 4.98 0 0 0-4.643-3.144H9.45a4.975 4.975 0 0 0-4.643 3.144L3.37 6.732a6 6 0 0 0-.305 3.443L5.1 20.012a5.02 5.02 0 0 0 4.896 3.987h3.944a5.02 5.02 0 0 0 4.896-3.987l2.035-9.837a6 6 0 0 0-.305-3.443zm-1.653 3.039-2.035 9.836A3.01 3.01 0 0 1 13.944 22H10a3.01 3.01 0 0 1-2.938-2.392L5.027 9.77c-.16-.77-.09-1.563.203-2.296l1.436-3.589A2.985 2.985 0 0 1 9.45 1.999h5.042c1.233 0 2.327.74 2.785 1.886l1.436 3.589c.292.73.362 1.525.203 2.297M16 9a1 1 0 0 1-1 1h-2v5a1 1 0 1 1-2 0v-5H9a1 1 0 1 1 0-2h2V6a1 1 0 1 1 2 0v2h2a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coffin-cross_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoffinCross;
